// assets
import { IconPackage } from "@tabler/icons";
import onpageoptimization from "../json/onpageoptimization";
import landingpageoptimization from "../json/landingpageoptimization";

// constant
const icons = {
  IconPackage,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const optimization = {
  id: "optimization",
  title: "Optimization",
  caption: "Optimization",
  type: "group",
  children: [
    {
      id: "optimization",
      title: "Optimization",
      type: "collapse",
      icon: icons.IconPackage,

      children: [
        {
          id: "landing-page-optimization",
          title: "Landing page optimization",
          titleType: "collapse",
          type: "item",
          url: "/landing-page-optimization",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/landingpage",
          jsonobject: landingpageoptimization,
          editorTitile: "Suggestions for improving the website's landing pages",
          mainTitile: "Landing page optimization",
          mainDescription:
            "This feature allows users to optimize their website's landing pages for better conversion rates by analyzing and providing suggestions for improvement.",
        },
        {
          id: "on-page-optimization",
          title: "On-page optimization",
          titleType: "collapse",
          type: "item",
          url: "/on-page-optimization",
          target: false,
          breadcrumbs: true,
          endPoint:"ai/onpageoptimization",
          jsonobject: onpageoptimization,
          editorTitile: "Optimized website content",
          mainTitile: "On-page optimization",
          mainDescription:
            "This feature includes optimizing elements on a website, such as title tags, meta tags, header tags, and keyword density, to ensure that they are in line with best practices and search engine algorithms.",
        },
      ],
    },
  ],
};

export default optimization;
